"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUserAction = exports.StyledPopoverContent = exports.StyledAvatar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledUserAction = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledUserAction",
  componentId: "sc-1mz6o1m-0"
})([".profile{.user-actions{display:flex;align-items:center;cursor:default;.avatar{width:28px;height:28px;overflow:hidden;img{max-width:100%;height:auto;border-radius:50%;}}.user-name{font-size:", ";line-height:", ";padding-left:22px;}}.content{right:0px;left:auto !important;transform:unset !important;.arrows{left:61%;}}}"], _shared.theme.typography.link.fontSize, _shared.theme.typography.link.lineHeight);

exports.StyledUserAction = StyledUserAction;

const StyledPopoverContent = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledPopoverContent",
  componentId: "sc-1mz6o1m-1"
})(["padding:36px 36px 15px;box-sizing:border-box;font-family:'Gilroy-Regular';.header{display:flex;padding:0px 0px 30px;.avatar{width:40px;img{max-width:100%;height:auto;}span{display:block;background-color:", ";border-radius:50%;width:40px;height:40px;overflow:hidden;}}.title{padding-left:20px;strong{font-family:", ";font-size:", ";line-height:", ";color:", ";}p{margin:0px;color:", ";font-size:", ";line-height:", ";letter-spacing:", ";}}}ul{list-style:none;padding:0px;margin:0px;li{a{font-size:", ";line-height:", ";letter-spacing:", ";text-decoration:none;color:", ";padding:10px 0px;display:block;}}}"], _shared.theme.palette.ui.neutral.grey2, _shared.theme.typography.body.fontFamily, _shared.theme.typography.body.fontSize, _shared.theme.typography.body.lineHeight, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.gray, _shared.theme.typography.h6.fontSize, _shared.theme.typography.h6.lineHeight, _shared.theme.typography.h6.letterSpacing, _shared.theme.typography.h5.fontSize, _shared.theme.typography.h5.lineHeight, _shared.theme.typography.h5.letterSpacing, _shared.theme.palette.brand.primary.charcoal);

exports.StyledPopoverContent = StyledPopoverContent;

const StyledAvatar = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledAvatar",
  componentId: "sc-1mz6o1m-2"
})(["width:", ";height:", ";border-radius:", ";background:", ";color:", ";display:flex;justify-content:center;align-items:center;font-family:Gilroy-SemiBold;font-size:", ";"], ({
  size
}) => size ? size : '28px', ({
  size
}) => size ? size : '28px', ({
  round
}) => round ? round : '', ({
  bgColor
}) => bgColor ? bgColor : _shared.theme.palette.brand.primary.charcoal, ({
  color
}) => color ? color : _shared.theme.palette.brand.primary.white, ({
  fSize
}) => fSize ? fSize : '10px');

exports.StyledAvatar = StyledAvatar;